import React from "react";
import styled, { withTheme } from "styled-components/native";
import BackgroundImage from "../image/BackgroundImage";
import ShiftView from "../view/ShiftView";
import Toast, { ToastContext } from "../toast";
import Logo from "../layout/Logo";
import { Form } from "cci-utility";

const OuterContainer = styled.View`
  position: absolute;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentView = styled(ShiftView)`
  width: ${props => props.theme.pageWidth || "27%"};
  min-width: 300px;
  flex-direction: column;
  align-items: stretch;
  ${props =>
    props.theme.pageContentFlex ? "flex: " + props.theme.pageContentFlex : ""}
`;

const BaseCenteredLogoPage = props => {
  const theme = props.theme;

  return (
    <Toast position="top" positionValue={20}>
      <OuterContainer>
        {/* Background image for the entire page */}
        {theme.pageBackgroundUrl && (
          <BackgroundImage
            source={theme.pageBackgroundUrl}
            style={{ opacity: theme.pageBackgroundOpacity }}
          />
        )}

        {/* Application logo */}
        {theme.logoUrl && <Logo source={theme.logoUrl} />}

        {/* Main content container which is a ShiftView (for shifting screen when text field is focused) */}
        <ContentView>{props.children}</ContentView>
      </OuterContainer>
    </Toast>
  );
};

export default withTheme(BaseCenteredLogoPage);
